import type { HarmonyPackageBoard } from '@rhythmic/db/types'
import type { UseLiveQueryReturn } from '@tanstack/vue-db'
import { createLiveQueryCollection, useLiveQuery } from '@tanstack/vue-db'
import { getBoardsCollection } from '../contexts'

export function useBoardsByHarmonyPlanId(
  planId: string | null | undefined,
): UseLiveQueryReturn<HarmonyPackageBoard> | undefined {
  if (!planId) {
    return undefined
  }

  const collection = getBoardsCollection(planId)

  const liveQuery = createLiveQueryCollection((q) =>
    q.from({ t: collection }).orderBy(({ t }) => (t as any).createdAt ?? '', 'desc'),
  )

  const query = useLiveQuery(liveQuery)

  return query
}
